<template>
 <v-dialog v-model="visible" persistent max-width="500px">
   <v-card>
     <v-card-text>
       <v-form ref="clientCreationForm" v-model="isValid" v-if="visible">
           <v-text-field
             v-model="newClient.title"
             label="Title"
             :rules="titleRules"
             required
           ></v-text-field>
           <v-text-field
             v-model="newClient.email"
             label="Email addresses (comma separated)"
            :rules="emailRules"
           ></v-text-field>
           <v-text-field
             v-model="newClient.inviteToDpCasesEmails"
             label="Invite to dp cases emails (comma separated)"
           ></v-text-field>
           <v-select
             :items="caseOriginators"
             v-model="newClient.caseOriginatorId"
             item-value="id"
             item-text="name"
             :rules="caseOriginatorRules"
             label="Case originator"
             max-height="400"
             persistent-hint
             required
           ></v-select>
           <v-text-field
             v-model="draftOriginatorClientIds"
             label="Originator client ids (comma separated)"
           ></v-text-field>
           <v-select
             :items="availableReportSendModes"
             v-model="newClient.reportSendMode"
             item-value="value"
             item-text="name"
             label="Report send mode"
             persistent-hint
             required
           ></v-select>
           <v-select
             :items="availableNoHeader"
             v-model="newClient.noHeader"
             item-value="value"
             item-text="name"
             label="Allow hide header"
             persistent-hint
             required
           ></v-select>
           <v-select
             :items="availableNoHeader"
             v-model="newClient.skipCalcStat"
             item-value="value"
             item-text="name"
             label="Exclude from statistic"
             persistent-hint
           ></v-select>
           <v-text-field
             v-model="newClient.address"
             label="Address of client"
           ></v-text-field>
          <v-select
             :items="availableContractors"
             v-model="newClient.contractorId"
             item-value="id"
             item-text="title"
             label="Client contractor"
             clearable
             persistent-hint
           ></v-select>
          <v-select
             :items="availableNoHeader"
             v-model="newClient.sendToPatientIfClientNoEmail"
             item-value="value"
             item-text="name"
             label="Send report to patient if no org email is set"
             persistent-hint
           ></v-select>
          <v-select
             :items="availableNoHeader"
             v-model="newClient.reportMustBePrinted"
             item-value="value"
             item-text="name"
             label="Report must be printed"
             persistent-hint
           ></v-select>
          <v-select
             :items="this.costCentersOptions"
             v-model="costCenterId"
             item-value="key"
             item-text="name"
             label="Cost center"
             persistent-hint
             clearable
             @click:clear="handleClearCostCenters"
           ></v-select>
           <v-autocomplete
             :items="this.regions"
             v-model="newClient.regionId"
             item-value="key"
             item-text="name"
             label="Region"
             persistent-hint
             v-show="!!costCenterId"
             :rules="costCenterRules"
           ></v-autocomplete> 
           <v-select
             :items="availableNoHeader"
             v-model="newClient.activeDiscount"
             item-value="value"
             item-text="name"
             label="Discount available"
             persistent-hint
           ></v-select>
           <v-select
             :items="availableNoHeader"
             v-model="newClient.private"
             item-value="value"
             item-text="name"
             label="Private"
             persistent-hint
           ></v-select>
           <v-alert
             :value="hasError"
             type="error"
             outline
           >
             {{ errorMessage }}
           </v-alert>
           <v-btn
             :disabled="!isValid"
             @click="handleOkClick"
           >
             Save
           </v-btn>
           <v-btn @click="handleCancelClick">Cancel</v-btn>
         </v-form>
     </v-card-text>
   </v-card>
 </v-dialog>
</template>

<style scoped>
.v-text-field {
    padding-top: 0px!important;
}
</style>

<script>
import _ from 'lodash'
import api from '../../api'
import thesaurus from '../../thesaurus-api'
import {extractErrorToString} from '../../helpers/api'

import { mapState } from 'vuex'

const emptyClient = {
  id: null,
  title: null,
  email: null,
  inviteToDpCasesEmails: null,
  caseOriginatorId: null,
  costCenterId: null,
  originatorClientIds: [],
  reportSendMode: 'manual',
  noHeader: false,
  skipCalcStat: false,
  address: '',
  contractorId: null,
  sendToPatientIfClientNoEmail: false,
  reportMustBePrinted: false,
  regionId: null,
  activeDiscount: false,
  private: false
}

export default {
  name: 'client-creation-form',
  props: {
    visible: {
      type: Boolean
    },
    caseOriginators: {
      type: Array
    },
    availableReportSendModes: {
      type: Array
    },
    selectedClientItem:{
      type: Object
    },
    availableContractors: {
      type: Array
    }
  },
  data () {
    return {
      draftOriginatorClientIds: null,
      hasError: null,
      loading: false,
      isValid: false,
      errorMessage: null,
      newClient: _.clone(emptyClient),
      availableNoHeader: [ { value: true, name: 'Yes' }, { value: false, name: 'No' } ],
      costCenterId: null,
      titleRules: [
        v => !!v || 'Enter client title',
        v => (v && v.length <= 1000) || 'The length of the name should be no more than 1000 characters'
      ],
      caseOriginatorRules: [
        v => !!v || 'Select case originator'
      ]
    }
  },
  beforeCreate () {
    
  },
  watch: {
    visible () {
      if (this.visible && this.selectedClientItem){
        this.newClient = _.clone(this.selectedClientItem)
        this.$nextTick(() => this.costCenterId = this.newClient.costCenterId)
      }
    },
    costCenterId: 'scheduleValidateField',
    'newClient.reportSendMode': 'scheduleValidateField',
    'newClient.email': 'scheduleValidateField'
  },
  computed: {
    ...mapState({
      allCostCentersMap: 'allCostCentersMap',
      allRegionsMap: 'allRegionsMap',
      regions: 'regions'
    }),
    costCentersOptions() {
      let arr = []
      for (const key in this.allCostCentersMap) {
        if (Object.hasOwnProperty.call(this.allCostCentersMap, key)) {
          const name = this.allCostCentersMap[key];
          arr.push({key, name})
        }
      }
      return arr
    },
    defaultRegionsOptions() {
      let arr = []
      for (const key in this.allRegions) {
        if (Object.hasOwnProperty.call(this.allRegions, key)) {
          const name = this.allRegions[key];
          arr.push({key, name})
        }
      }
      return arr
    },
    costCenterRules() {
      if (this.costCenterId && !this.newClient.regionId ) {
        this.$nextTick(() => this.validateField())
        return [() => 'Select region']
      }
      return [() => true]
    },
    emailRules() {
      const reportSendMode = this.newClient.reportSendMode
      const normalizedReportSendMode = _.toLower(
        _.trim(_.isObject(reportSendMode) ? reportSendMode.value : reportSendMode)
      )

      if (normalizedReportSendMode !== 'auto') {
        return [() => true]
      }

      return [v => {
        const emails = _.chain(_.split(v || '', ','))
          .map(item => _.trim(item))
          .filter(item => item.length > 0)
          .value()

        return emails.length > 0 || 'Enter at least one email for Auto mode'
      }]
    }
  },
  methods: {
    async handleOkClick () {
      this.hasError = null
      this.errorMessage = null

      if (this.newClient.email !== null && this.newClient.email.length === 0) {
        this.newClient.email = null
      }

      if (this.draftOriginatorClientIds !== null) {
        this.newClient.originatorClientIds = _.filter(_.map(_.split(this.draftOriginatorClientIds, ','),
          (elem) => {
            return _.trim(elem)
          }),
        (id) => {
          return id.length > 0
        })
      }

      this.newClient.costCenterId = this.costCenterId

      if (this.newClient.id) {
        try {
          let updatedItem = await api.updateClient(this.newClient)
          this.resetNewClient()
          this.$emit('updated', updatedItem)
        } catch (e) {
          this.hasError = true
          this.errorMessage = extractErrorToString(e, 'Unable to update client')
        }
        return
      }
      try {
        await api.createClient(this.newClient)
        this.resetNewClient()
        this.$emit('created')
      } catch (e) {
        this.hasError = true
        this.errorMessage = extractErrorToString(e, 'Unable to create client')
      }
    },
    handleCancelClick () {
      this.resetNewClient()
      this.$emit('close')
    },
    resetNewClient () {
      this.hasError = null
      this.errorMessage = null
      this.$refs.clientCreationForm.reset()
      this.newClient = _.clone(emptyClient)
      this.costCenterId = this.newClient.costCenterId
      this.draftOriginatorClientIds = null
    },
    handleClearCostCenters () {
      this.$nextTick(() => {
        this.costCenterId = null
        this.newClient.costCenterId = null
        this.newClient.regionId = null
      })
    },
    regionsToOptions(regions) {
      return regions.map(elem => {
        return {
          key: elem.code,
          name: elem.text
        }
      })
    },
    validateField () {
      this.$refs.clientCreationForm.validate()
    },
    scheduleValidateField () {
      this.$nextTick(() => this.validateField())
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/ClientCreationForm.vue